import { render } from "./LogoImg.vue?vue&type=template&id=3bb9bf44&scoped=true&ts=true"
import script from "./LogoImg.vue?vue&type=script&lang=ts"
export * from "./LogoImg.vue?vue&type=script&lang=ts"

import "./LogoImg.vue?vue&type=style&index=0&id=3bb9bf44&scoped=true&lang=css"

import exportComponent from "/home/runner/work/a-gallery-tvp/a-gallery-tvp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb9bf44"]])

export default __exports__